<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="900px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        block
        class="white--text"
        v-on="on"
      >
        Create Claim Type
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Claim Type"
      text="Create Claim Type"
      class="mb-0"
    > 
      <v-container v-if="dialog">
        <v-row no-gutters>
          <v-col
            cols="12"
            class="py-0"
          >
            <v-text-field
              v-model="claimType"
              v-validate="'required'"
              :error-messages="errors.collect('claimType')"
              data-vv-name="claimType"
              data-vv-as="claim type"
              label="Claim Type"
              class="my-0"
            />
            <v-autocomplete
              v-model="expenseType"
              v-validate="'required'"
              :error-messages="errors.collect('expenseType')"
              data-vv-name="expenseType"  
              data-vv-as="expense type"  
              :items="expenseTypes"
              label="Expense Type"
              item-text="name"
              item-value="name"
              class="my-0"
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <div class="font-weight-bold">
                    {{ data.item.name }}
                  </div>
                  <div>{{ data.item.description }}</div>
                </v-list-item-content>
              </template>
            </v-autocomplete>
            <v-autocomplete
              v-model="claimedBy"
              v-validate="'required'"
              :error-messages="errors.collect('claimedBy')"
              data-vv-name="claimedBy"  
              data-vv-as="claimed by"  
              :items="claimModels"
              label="Claim By"
              item-text="name"
              item-value="name"
              class="my-0"
            />
          </v-col>

          <v-col
            v-if="expenseType === 'Mileage' || expenseType === 'Per unit allowance'"
            cols="12"
            class="py-0 my-0"
          >
            <v-divider />
            <v-row>
              <v-col>
                <span class="font-weight-bold pr-2">Claim Type Details:</span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-icon
                      color="primary"
                      v-on="{ ...dialog, ...tooltip }"
                      @click="addRow"
                    >
                      mdi-plus
                    </v-icon>
                  </template>
                  <span>Add new detail</span>
                </v-tooltip>
              </v-col>
            </v-row>

            <v-row
              v-for="(detail,counter) in details"
              :key="counter"
              class="align-center pb-4"
            >
              <v-col
                cols="5"
                class="py-0"
              >
                <v-text-field
                  v-model="detail.name"
                  v-validate="'required'"
                  :name="'name' + counter"
                  :error-messages="errors.collect('name' + counter)"
                  data-vv-delay="500"
                  data-vv-as="detail"
                  placeholder="Detail (Requirement / Type)"
                  autocomplete="off"
                />
              </v-col>
              <v-col
                cols="3"
                class="py-0"
              >
                <v-text-field
                  v-model="detail.amount"
                  v-money="money"
                  :name="'amount' + counter"
                  :error-messages="errors.collect('amount' + counter)"
                  data-vv-delay="500"  
                  data-vv-name="amount"
                  label="Amount"
                  prefix="RM"
                />
              </v-col>
              <v-col
                cols="3"
                class="py-0"
              >
                <v-autocomplete
                  v-model="detail.unit_of_measurement"
                  v-validate="'required'"
                  :name="'unit_of_measurement' + counter"
                  :error-messages="errors.collect('unit_of_measurement' + counter)"
                  data-vv-delay="500"
                  data-vv-as="unit"
                  label="Unit"
                  prefix="/"
                  :items="filteredUnits"
                  item-text="value"
                  item-value="value"
                  autocomplete="off"
                />
              </v-col>

              <v-col class="text-center">
                <v-icon
                  color="error"
                  @click="deleteRow(counter)"
                >
                  mdi-window-close
                </v-icon>
              </v-col>
            </v-row>
            <v-divider />
          </v-col>
          
          <v-col
            cols="4"
            class="pt-2"
          >
            <span> Requires document? </span>
            <v-radio-group
              v-model="requiresDocument"
              class="mt-0"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            cols="4"
            class="pt-2"
          >
            <span> Requires confirmation? </span>
            <v-radio-group
              v-model="requiresConfirmation"
              class="mt-0"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            cols="4"
            class="pt-2"
          >
            <span> Requires receipt? </span>
            <v-radio-group
              v-model="requiresReceipt"
              class="mt-0"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            cols="4"
            class="py-0 my-0"
          >
            <span> Is description mandatory? </span>
            <v-radio-group
              v-model="isDescriptionMandatory"
              class="mt-0"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            cols="4"
            class="py-0 my-0"
          >
            <span> Has limit? </span>
            <v-radio-group
              v-model="hasLimit"
              class="mt-0"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            v-if="hasLimit"
            cols="4"
            class="py-0 my-0"
          >
            <span> Allow exceed limit? </span>
            <v-radio-group
              v-model="allowExceedLimit"
              class="mt-0"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            v-if="requiresReceipt"
            cols="4"
            class="py-0 my-0"
          >
            <span> Allow advance purchase? </span>
            <v-radio-group
              v-model="allowAdvancePurchase"
              class="mt-0"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            cols="4"
            class="py-0 my-0"
          >
            <span> Allow higher superior approval? </span>
            <v-radio-group
              v-model="allowHigherLevelApproval"
              class="mt-0"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            cols="4"
            class="py-0 my-0"
          >
            <span> Requires declaration? </span>
            <v-radio-group
              v-model="requiresDeclaration"
              class="mt-0"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>

          <v-col
            v-if="requiresDeclaration"
            cols="12"
            class="pb-8"
          >
            <tiptap-vuetify
              v-model="declarationText"
              v-validate="'required'"
              :name="declarationText"
              class="full-width text-editor-toolbar-height pb-1"
              placeholder="Declaration Text"
              :extensions="extensions"
            />
            <span 
              v-if="errors.has('declarationText')"
              class="red--text" 
            >
              {{ errors.first('declarationText') }}
            </span>
          </v-col>

          <v-col
            cols="12"
            class="py-0 my-0"
          >
            <v-divider />
            <v-row>
              <v-col>
                <span class="font-weight-bold pr-2">Custom fields (Collect additional information for this claim type):</span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-icon
                      color="primary"
                      v-on="{ ...dialog, ...tooltip }"
                      @click="addCustomFieldRow"
                    >
                      mdi-plus
                    </v-icon>
                  </template>
                  <span>Add new custom field</span>
                </v-tooltip>
              </v-col>
            </v-row>

            <v-row
              v-for="(field,counter) in customFields"
              :key="counter"
              class="align-center"
            >
              <v-col
                cols="4"
                class="py-0"
              >
                <v-text-field
                  v-model="field.name"
                  v-validate="'required'"
                  :name="'field_name' + counter"
                  :error-messages="errors.collect('field_name' + counter)"
                  data-vv-delay="500"
                  data-vv-as="title"
                  placeholder="Title"
                  autocomplete="off"
                />
              </v-col>
              <v-col
                cols="2"
                class="py-0"
              >
                <v-checkbox
                  v-model="field.is_mandatory"
                  :name="'is_mandatory' + counter"
                  color="green"
                  label="Mandatory?"
                />
              </v-col>
              <v-col
                cols="5"
                class="py-0 ml-4"
              >
                <v-autocomplete
                  v-model="field.type"
                  v-validate="'required'"
                  :name="'type' + counter"
                  :error-messages="errors.collect('type' + counter)"
                  data-vv-delay="500"
                  data-vv-as="type"
                  :items="fieldTypes"
                  label="Field Type"
                  item-text="name"
                  item-value="name"
                  class="my-0"
                  autocomplete="off"
                  @change="field.selections = []"
                />
              </v-col>
              
              <v-col 
                class="text-center"
              >
                <v-icon
                  color="error"
                  @click="deleteCustomFieldRow(counter)"
                >
                  mdi-window-close
                </v-icon>
              </v-col>

              <v-col
                cols="6"
                class="pb-0"
              />
              <v-col
                v-if="field.type === 'Selection'"
                cols="5"
                class="pb-0 ml-4"
              >
                <v-combobox
                  v-model="field.selections"
                  v-validate="'required'"
                  :name="'selection' + counter"
                  :error-messages="errors.collect('selection' + counter)"
                  data-vv-delay="500"
                  data-vv-as="selection"
                  label="Selections"
                  :placeholder="field.name ? 'Type to add selections for ' + field.name : 'Type to add selections'"
                  hint="Type and press enter to add a new selection"
                  persistent-hint
                  outlined
                  multiple
                  chips
                  small-chips
                  deletable-chips
                  clearable
                  append-icon=""
                  autocomplete="off"
                />
              </v-col>
            </v-row>
            <v-divider />
          </v-col>
        </v-row>
        
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="progressing"
            text
            class="px-10"
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            :loading="progressing"
            color="hrissecondary"   
            class="white--text px-10"       
            @click="submitForm"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-container>
    </material-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  import { VMoney } from 'v-money'
  import { TiptapVuetify, Bold, Italic, Underline, BulletList, OrderedList, ListItem, HardBreak } from 'tiptap-vuetify'

  export default {
    directives: { money: VMoney },
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      TiptapVuetify,
    },
    data () {
      return {
        dialog: false,        
        progressing: false,
        expenseTypes: [
          { 'name': 'Generic', 'description': 'Expense where the amount keyed is the reimbursement amount' },
          { 'name': 'Mileage', 'description': 'Expense that require the distance travelled in KM' },
          { 'name': 'Per unit allowance', 'description': 'Expense that based on daily rates/transaction, rates are the same for all job categories' },
        ],
        claimModels: ['Employee', 'Department'],
        expenseType: null,
        claimedBy: null,
        claimType: null,
        requiresDocument: 1,
        requiresReceipt: 1,
        requiresConfirmation: 0,
        isDescriptionMandatory: 0,
        allowAdvancePurchase: 0,
        hasLimit: 1,
        allowExceedLimit: 0,
        allowHigherLevelApproval: 0,
        requiresDeclaration: 0,
        declarationText: '',
        details: [],
        customFields: [],
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
        fieldTypes: ['Text', 'Number', 'Date', 'Selection'],
        extensions: [
          Bold,
          Italic,
          Underline,
          ListItem,
          BulletList,
          OrderedList,
          HardBreak,
        ],
      }
    },
    computed: {
      ...mapState('lookup', ['claim_unit_of_measurement']),
    },
    watch: {
      expenseType: {
        immediate: true,
        handler (value) {
          if (value === 'Mileage' || value === 'Per unit allowance') {
            if (this.details.length === 0) {
              this.addRow()
            }

            if (!this.claim_unit_of_measurement || this.claim_unit_of_measurement.length === 0) {
              this.filteredUnits = []
            } else {
              if (value === 'Mileage') {
                this.filteredUnits = this.claim_unit_of_measurement.filter(u => u.grouping === 'distance_unit')
              } else {
                this.filteredUnits = this.claim_unit_of_measurement.filter(u => u.grouping === 'allowance_unit')
              }
            }
          } else {
            this.details = []
          }
        },
      },
      declarationText () {
        if (this.requiresDeclaration) this.validateDeclarationText()
      },
    },
    methods: {
      formatDeclarationText () {
        if (!this.declarationText) return ''

        return this.declarationText
          // unwrap <p> tags inside <li>
          .replace(/<li>\s*<p>(.*?)<\/p>\s*<\/li>/g, '<li>$1</li>')
          // replace </p><p> boundaries with <br> (preserve line breaks)
          .replace(/<\/p>\s*<p>/g, '<br>')
          // remove remaining <p> and </p>
          .replace(/<\/?p>/g, '')
      },
      validateDeclarationText () {
        const cleanedHtml = this.formatDeclarationText()

        const text = cleanedHtml.replace(/<[^>]*>/g, '').trim()

        if (!text) {
          // Manually set error in vee-validate
          this.errors.add({ field: 'declarationText', msg: 'Declaration text is required' })
          return false
        } else {
          this.errors.remove('declarationText')
          return true
        }
      },
      addRow () {
        this.details.push({ name: '', amount: 0.00, unit_of_measurement: '' })
      },
      deleteRow (counter) {
        this.details.splice(counter, 1)
      },
      addCustomFieldRow () {
        this.customFields.push({ name: '', is_mandatory: true, type: null })
      },
      deleteCustomFieldRow (counter) {
        this.customFields.splice(counter, 1)
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            const declarationValid = this.requiresDeclaration ? this.validateDeclarationText() : true

            if (!result || !declarationValid) return 

            this.progressing = true
    
            this.$api.claimTypes().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 200 || res.status === 201) {
                  this.$emit('created')              
                  this.$snack({ message: 'Added new claim type' })
                  this.$resetData()
                  this.dialog = false                 
                }
              })
              .catch(error => {
                if (error.response.status === 400) {
                  if (this.expenseType !== 'Generic' && this.details.length <= 0) {
                    this.addRow()
                  }

                  this.$snack({ 
                    color: 'error',
                    message: error.response.data.message, 
                  })
                } else {
                  this.$snack({
                    color: 'error',
                    message: 'Failed to create new claim type',
                  })
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          name: this.claimType,
          expense_type: this.expenseType.toLowerCase(),
          claimed_by: this.claimedBy.toLowerCase(),
          requires_document: this.requiresDocument,
          requires_confirmation: this.requiresConfirmation,
          is_description_mandatory: this.isDescriptionMandatory,
          requires_receipt: this.requiresReceipt,
          allow_advance_purchase: this.requiresReceipt ? this.allowAdvancePurchase : 0,
          has_limit: this.hasLimit,
          allow_exceed_limit: this.hasLimit ? this.allowExceedLimit : 0,
          allow_higher_level_approval: this.allowHigherLevelApproval,
          requires_declaration: this.requiresDeclaration,
          declaration_text: this.requiresDeclaration ? this.formatDeclarationText() : null,
          details: this.details,
          custom_fields: this.customFields,
        }
      },
    },
  }
</script>
